import { render, staticRenderFns } from "./ProductDeleter.vue?vue&type=template&id=9e6fe84c&"
import script from "./ProductDeleter.vue?vue&type=script&lang=js&"
export * from "./ProductDeleter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports